var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.expanded ? 'expanded' : 'collapsed',style:('max-width: ' + _vm.panelWidth + 'px;'),attrs:{"id":"messenger"}},[_c('div',{attrs:{"id":"messengerPanel"}},[_c('MessengerContent',{attrs:{"expanded":_vm.expanded},on:{"sendMessage":_vm.sendMessage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }